import React, { useEffect, useState } from "react";
import Filters from "./Filters";
import { PropertiesObj } from "../../Models/PropertiesObj";
import { DropProperties, DropProperty, DuplicatePropertiesServ, getListings, PublishPropertiesServ, SearchFilter, UpdatePropertyService, UploadPropertiesXml } from "../../Services/Properties";
import { FilterProperties } from "../../Models/FilterProperties";
import { Badge, Pagination } from "@mui/material";
import DownoaldXML from "./download-xml-properties";
import PublishProperties from "./publish-properties";
import UnPublishProperties from "./unpublish-properties";
import DeleteProperties from "./delete-properties";
import DeleteProperty from "./delete-property";
import UploadProperties from "./upload-properties";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import SortByProperties from "./sort-by-properties";
import { useNavigate } from "react-router-dom";
import SortByStatus from "./sort-by-status";
import { GetTemplateServ } from "../../Services/Generate";
import DuplicateProperties from "./duplicate-properties";
import EditListing from "../edit-listing/edit-listing";
import { useTranslation } from "react-i18next";
import Search from "./search";
import TutorialButton from "../Home/toturial";

const Properties: React.FunctionComponent<{}> = (props) => {

    const seo = {
        "name": "SEO optimazed",
        "length": "Short and Concise",
        "tone": "Formal and Professional",
        "style": "Rustic and Charming",
        "minCharactersDesc": 1000,
        "maxCharactersDesc": 1300,
        "minCharactersTitle": 50,
        "maxCharactersTitle": 76,
        "template": "seo_optimized",
        "imagesAnalysis": true,
        "agencyIntroduction": true,
    }
    const defaultDesc = {
        name: "Default",
        length: "Detailed and Elaborate",
        tone: "Cozy and Inviting",
        style: "Modern and Sleek",
        minCharactersDesc: 1200,
        maxCharactersDesc: 1500,
        minCharactersTitle: 50,
        maxCharactersTitle: 100,
        imagesAnalysis: true,
        template: "default",
        agencyIntroduction: true,
    }
    const [loading, setLoading] = useState(true);
    const [propertiesData, setPropertiesData] = useState<PropertiesObj>();
    const [filterOptionsValue, setFilterOptionsValue] = useState<FilterProperties>({});
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [totalPage, setTotalPage] = useState<number>(1);
    const [propertiesLenght, setPropertiesLenght] = useState<any>();
    const [isLoadingData, setLoadingData] = useState<boolean>(true);
    const [selectedProperties, setSelectedProperties] = useState<any>([]);
    const [isChange, setIsChange] = useState<boolean>(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [message, setMessage] = useState<string>();
    const [colorSnackbar, setColorSnackbar] = useState<any>("");
    const [isCollapseOpen, setIsCollapseOpen] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        getListings(filterOptionsValue, pageNumber).then((data) => {
            setTotalPage(Math.ceil(data.total / 8))
            setPropertiesData(data);
            setLoading(false)
            setPropertiesLenght(data.total)
            localStorage.setItem("LenghtListings", JSON.stringify(data.total))
            setLoadingData(false)
        }).catch((error) => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage(error.response.data.message)
        })
    }, [isChange, filterOptionsValue])


    /*************Filter*********** */

    const ChangeFilterHandler = (value: FilterProperties) => {
        setFilterOptionsValue(value);
        setIsChange(!isChange);
        // setIsCollapseOpen(false);
    }

    const toggleCollapse = () => {
        setIsCollapseOpen((prevState) => !prevState);
    }

    const getAppliedFiltersCount = () => {
        return Object.entries(filterOptionsValue)
            .filter(([key, value]) => {
                if (key === "sortBy" || key === "low_to_high" || key === "high_to_low") {
                    return false;
                }
                if (Array.isArray(value)) {
                    return value.some((v) => v !== null && v !== "");
                }
                return value !== null && value !== "";
            }).length;
    }

    const handleSelectChangeSortBy = (value: FilterProperties) => {
        setFilterOptionsValue(value);
        setIsChange(!isChange);
    }

    const SearchHandler = (value: any) => {
        setFilterOptionsValue((prevState) => {
            const newState = {
                ...prevState,
                search: value,
            };
            return newState;
        });
        setIsChange(!isChange);
    }

    /*************Select Property*********** */

    const isSelected = (propertyId: any) => selectedProperties.includes(propertyId);

    const handleSelectAllProperties = (e: any) => {
        if (e.target.checked) {
            const allIds: any = propertiesData?.properties.map(property => property._id);
            setSelectedProperties(allIds);
        } else {
            setSelectedProperties([]);
        }
    }

    const handleSelectProperty = (propertyId: any) => {
        setSelectedProperties((prevSelected: any) => {
            if (prevSelected.includes(propertyId)) {
                return prevSelected.filter((id: any) => id !== propertyId);
            } else {
                return [...prevSelected, propertyId];
            }
        });
    }

    /*************Pagination*********** */

    const handleChangePagination = (event: React.ChangeEvent<unknown>, value: number) => {
        setPageNumber(value)
        setIsChange(!isChange)
    }

    /*************Duplicate*********** */

    const DuplicatePropertyHandler = (listings: any) => {
        setSelectedProperties([])
        DuplicatePropertiesServ(listings).then((data: any) => {
            setMessage("Listing duplicated successfully!")
            setIsChange(!isChange)
            setColorSnackbar("success")
            setOpenSnackbar(true)
        }).catch((error: any) => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage("Failed to duplicate property!")
        })
        setTimeout(() => {
            setOpenSnackbar(false)
        }, 4000)
    }

    /*************Publish*********** */

    const PublishPropertyHandler = (listings: any) => {
        setSelectedProperties([])
        PublishPropertiesServ(listings).then((data: any) => {
            setMessage(data.message)
            setIsChange(!isChange)
            setColorSnackbar("success")
            setOpenSnackbar(true)
        }).catch((error: any) => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage(error.response.data.message)
        })
        setTimeout(() => {
            setOpenSnackbar(false)
        }, 4000)
    }

    /*************Upload Xml*********** */

    const UploadXmlHandler = (obj: any) => {
        setLoadingData(true)
        setMessage(obj.msg)
        setIsChange(!isChange)
        setColorSnackbar(obj.color)
        setOpenSnackbar(true)
    }

    /*************Actions*********** */

    const DeletePropertiesHandler = (listings: any) => {
        DropProperties(listings).then((data: any) => {
            setMessage(data.message)
            setIsChange(!isChange)
            setColorSnackbar("success")
            setOpenSnackbar(true)
        }).catch((error: any) => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage(error.response.data.message)
        })
        setTimeout(() => {
            setOpenSnackbar(false)
        }, 4000)
    }

    const DeletePropertyHandler = (id: any) => {
        DropProperty(id).then((data: any) => {
            setMessage(data.message)
            setIsChange(!isChange)
            setColorSnackbar("success")
            setOpenSnackbar(true)
        }).catch((error: any) => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage(error.response.data.message)
        })
        setTimeout(() => {
            setOpenSnackbar(false)
        }, 4000)
    }

    const view = (id: any) => {
        window.open(`/properties/${id}`, '_blank');
    }

    const UpdatePropertyHandler = (property: any, id: any) => {
        UpdatePropertyService(property, id).then((data) => {
            setMessage("Listing Updated Successfully !");
            setIsChange(!isChange)
            setColorSnackbar("success")
            setOpenSnackbar(true)
        }).catch((error: any) => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage("Failed to update property.")
        })
        setTimeout(() => {
            setOpenSnackbar(false)
        }, 4000)
    }

    const AddNewProperty = () => {
        sessionStorage.removeItem("listing");
        sessionStorage.removeItem("property_details");
        sessionStorage.removeItem("processid");
        sessionStorage.removeItem("taps");
        sessionStorage.removeItem("propertyId");
        sessionStorage.removeItem("progress");
        sessionStorage.removeItem("stastics")

        navigate("/Listing-Creation");
    }

    const handleCloseSnackbar = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };


    return loading ? <div className="container-xxl flex-grow-1 container-p-y marg-bottom-100 "></div> : (
        <div className="container-xxl flex-grow-1 container-p-y marg-bottom-100 ">
            <div className="row mb-3">
                <div className="col-md-6 d-flex">
                    <div className="marg-right-10">
                        <button className="buuton-next border-trans marg-right-10 marg-right-16 back-FFFFFF border-9" >
                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 14L13 7" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6 14L13 7" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6 14H22.3333" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6 14H22.3333" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6 14L13 21" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6 14L13 21" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                    <div className="mb-4">
                        <h1 className="title-24 color-black mb-2">{t('propertiesPage.title')}</h1>
                        <p className="para-16 color-39393B">{t('propertiesPage.description')}</p>
                    </div>
                </div>
                <div className="col-md-6 d-flex justify-content-end align-items-start">
                    <UploadProperties OnUploadXml={UploadXmlHandler} />
                    <button type="submit" className="button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30 padd-15-mb" onClick={AddNewProperty}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_23_299)">
                                <path d="M8 3.33334V12.6667" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M3.33203 8H12.6654" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_23_299">
                                    <rect width="16" height="16" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        {t('propertiesPage.addNew')}
                    </button>
                </div>
            </div>
            <div className="row">
                  <div className="col-md-4 mb-3">
                    <Search onSearch={SearchHandler} />
                </div>
                <div className="col-md-8 mb-3 col-filter">
                    <Badge color="error" badgeContent={getAppliedFiltersCount()} anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}
                        sx={{
                            "& .MuiBadge-badge": {
                                backgroundColor: "#FF002E",
                                color: "white",
                                fontFamily: 'Plus Jakarta Sans',
                                fontSize: "14px",
                                fontWeight: "500",
                                width: "24px",
                                height: "24px",
                                borderRadius: "12px"
                            },
                        }}>
                        <button className="btn-filter border-trans" type="button" onClick={toggleCollapse}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_23_646" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                    <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_23_646)">
                                    <path d="M10 18V16H14V18H10ZM6 13V11H18V13H6ZM3 8V6H21V8H3Z" fill="#1C1B1F" />
                                </g>
                            </svg>
                            {t('propertiesPage.filter')}
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_23_650)">
                                    <path d="M4 6L8 10L12 6" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_23_650">
                                        <rect width="16" height="16" fill="white" transform="matrix(1 0 0 -1 0 16)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </Badge>
                </div>
                    {isCollapseOpen && (
                        <div className="filters-container">
                            <Filters filterOptionsValue={filterOptionsValue} OnChangeFilter={ChangeFilterHandler} />
                        </div>
                    )}
                <div>
                    <div className="mb-4">
                        <TutorialButton />
                    </div>
                </div>
            </div>

            <div className="row marg-bottom-50">
                <div className="card border-3 border-0-2">
                    <div className="row padd-15-30">
                        <div className="col-md-4 mb-3">
                            <h3 className="title-18">{t('navbar.balanceCard.listing')} </h3>
                            <p className="para-14 color-475569">{t('propertiesPage.YouHave')} <span className="bold-700 color-0F172A"> {propertiesLenght} </span> {t('propertiesPage.listingsL')}</p>
                        </div>
                        <div className="col-md-8 d-flex-end overflow-x">
                            <DeleteProperties properties={selectedProperties} onDeleteProperties={DeletePropertiesHandler} />
                            <UnPublishProperties properties={selectedProperties} onPublishProperty={PublishPropertyHandler} toogle="unpublish-property-web" />
                            <DownoaldXML idProperty="" toogle="download-web" />
                            <DuplicateProperties properties={selectedProperties} onDuplicateProperty={DuplicatePropertyHandler} />
                            <PublishProperties properties={selectedProperties} onPublishProperty={PublishPropertyHandler} toogle="publish-property-web" />
                        </div>
                    </div>
                    <div className="table-responsive text-nowrap ">
                        <table className="table" >
                            <thead className="table-thead">
                                <tr>
                                    <th className="width-80">
                                        <input type="checkbox" className="form-check-input border-1-5 back-trans " onChange={handleSelectAllProperties}
                                            checked={propertiesData?.properties && propertiesData?.properties.length > 0 && selectedProperties.length === propertiesData?.properties.length} />
                                    </th>
                                    <th>  {t('propertiesPage.image')}</th>
                                    <th>
                                        <div className="d-flex align-items-center justify-content-center"> {t('propertiesPage.id')}
                                            <SortByProperties filterOptionsValue={filterOptionsValue} OnSelectChangeSortBy={handleSelectChangeSortBy} thead="ID" />
                                        </div>
                                    </th>
                                    <th>
                                        <div className="d-flex align-items-center justify-content-center">  {t('propertiesPage.titleHeader')}
                                            <SortByProperties filterOptionsValue={filterOptionsValue} OnSelectChangeSortBy={handleSelectChangeSortBy} thead="title" />
                                        </div>
                                    </th>
                                    <th>  {t('propertiesPage.property')}
                                    </th>
                                    <th>
                                        <div className="d-flex align-items-center justify-content-center">   {t('propertiesPage.location')}
                                            <SortByProperties filterOptionsValue={filterOptionsValue} OnSelectChangeSortBy={handleSelectChangeSortBy} thead="location" />
                                        </div>
                                    </th>
                                    <th>
                                        <div className="d-flex align-items-center justify-content-center">  {t('propertiesPage.agent')}
                                            <SortByProperties filterOptionsValue={filterOptionsValue} OnSelectChangeSortBy={handleSelectChangeSortBy} thead="agent" />
                                        </div>
                                    </th>
                                    <th>
                                        <div className="d-flex align-items-center justify-content-center">  {t('propertiesPage.status')}
                                            <SortByStatus filterOptionsValue={filterOptionsValue} OnSelectChangeSortBy={handleSelectChangeSortBy} />
                                        </div>
                                    </th>
                                    <th>  {t('propertiesPage.actions')} </th>
                                </tr>
                            </thead>
                            <tbody className="table-tbody">
                                {propertiesData?.properties.map((lines: any, index: any) => {
                                    return <tr key={"line_" + index} className={`${selectedProperties.includes(lines._id) ? "back-active" : ""}`}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={isSelected(lines._id)}
                                                onChange={() => handleSelectProperty(lines._id)}
                                            />
                                        </td>
                                        <td>
                                            {lines.content.images[0] ? <img src={lines.content.images[0].src} alt="property" className="prop-image" /> : <></>}
                                        </td>
                                        <td>{lines.id ? ((lines.id.length > 10) ? lines.id.slice(0, 10) + '...' : lines.id) : <></>}</td>
                                        <td>{(Array.isArray(lines.content.title) && lines.content.title.length > 0 && lines.content.title[0].title) ? ((lines.content.title[0].title.length > 20) ? lines.content.title[0].title.slice(0, 20) + '...' : lines.content.title[0].title) : <></>}</td>
                                        <td>
                                            <svg width="16" height="16" className="marg-right-5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_1117_2020)">
                                                    <path d="M12.2188 7.65625C12.2188 7.13931 11.7982 6.71875 11.2812 6.71875H10.3438C9.82681 6.71875 9.40625 7.13931 9.40625 7.65625V10.9375H12.2188V7.65625Z" fill="black" fillOpacity="0.8" />
                                                    <path d="M1.90625 2.34375C1.90625 1.56844 2.53719 0.9375 3.3125 0.9375H4.25C4.88356 0.9375 5.4205 1.35888 5.59575 1.936C4.55756 2.17669 3.78125 3.10844 3.78125 4.21875V4.6875H8.46875V4.21875C8.46875 3.07288 7.64197 2.11709 6.55375 1.915C6.35166 0.826687 5.39575 0 4.25 0H3.3125C2.02031 0 0.96875 1.05125 0.96875 2.34375V6.71875H1.90625V2.34375Z" fill="black" fillOpacity="0.8" />
                                                    <path d="M13.1562 11.875H8.46875V10.4688H0.96875V11.875C0.96875 13.1016 1.64531 14.1729 2.64475 14.7359L2.04356 15.3371L2.70644 16L3.61253 15.0939C3.81881 15.1347 4.03194 15.1562 4.25 15.1562H11.75C11.9681 15.1562 12.1812 15.1347 12.3875 15.0939L13.2936 16L13.9565 15.3371L13.3553 14.7359C14.3547 14.1729 15.0312 13.1016 15.0312 11.875V10.4688H13.1562V11.875Z" fill="black" fillOpacity="0.8" />
                                                    <path d="M15.0625 7.65625H13.1562V9.53125H15.0625C15.5794 9.53125 16 9.11063 16 8.59375C16 8.07687 15.5794 7.65625 15.0625 7.65625Z" fill="black" fillOpacity="0.8" />
                                                    <path d="M8.46875 7.65625H0.9375C0.420625 7.65625 0 8.07687 0 8.59375C0 9.11063 0.420625 9.53125 0.9375 9.53125H8.46875V7.65625Z" fill="black" fillOpacity="0.8" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1117_2020">
                                                        <rect width="16" height="16" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            {lines.content.bathroom ? lines.content.bathroom : ""}
                                            <svg width="16" height="16" className="marg-left-10 marg-right-5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.5 7.20938C13.1848 7.071 12.8442 6.9997 12.5 7H3.5C3.15578 6.99967 2.81525 7.07086 2.5 7.20906C2.05444 7.40391 1.67529 7.72435 1.4089 8.1312C1.14252 8.53805 1.00043 9.0137 1 9.5V13C1 13.1326 1.05268 13.2598 1.14645 13.3536C1.24021 13.4473 1.36739 13.5 1.5 13.5C1.63261 13.5 1.75979 13.4473 1.85355 13.3536C1.94732 13.2598 2 13.1326 2 13V12.75C2.00081 12.6839 2.02741 12.6208 2.07412 12.5741C2.12083 12.5274 2.18395 12.5008 2.25 12.5H13.75C13.8161 12.5008 13.8792 12.5274 13.9259 12.5741C13.9726 12.6208 13.9992 12.6839 14 12.75V13C14 13.1326 14.0527 13.2598 14.1464 13.3536C14.2402 13.4473 14.3674 13.5 14.5 13.5C14.6326 13.5 14.7598 13.4473 14.8536 13.3536C14.9473 13.2598 15 13.1326 15 13V9.5C14.9995 9.01375 14.8574 8.53817 14.591 8.13138C14.3246 7.72459 13.9455 7.4042 13.5 7.20938Z" fill="black" fillOpacity="0.8" />
                                                <path d="M11.75 2.5H4.25C3.78587 2.5 3.34075 2.68437 3.01256 3.01256C2.68437 3.34075 2.5 3.78587 2.5 4.25V6.5C2.50001 6.51937 2.50453 6.53847 2.51319 6.5558C2.52185 6.57313 2.53442 6.5882 2.54991 6.59984C2.56539 6.61148 2.58337 6.61935 2.60242 6.62285C2.62147 6.62635 2.64108 6.62538 2.65969 6.62C2.93264 6.54017 3.21561 6.49976 3.5 6.5H3.63219C3.66304 6.5002 3.69288 6.48897 3.71595 6.46849C3.73903 6.44801 3.75372 6.41972 3.75719 6.38906C3.78446 6.14475 3.90077 5.91904 4.0839 5.75504C4.26704 5.59104 4.50417 5.50025 4.75 5.5H6.5C6.74599 5.50002 6.98335 5.59071 7.16668 5.75473C7.35002 5.91875 7.46646 6.14459 7.49375 6.38906C7.49722 6.41972 7.51191 6.44801 7.53498 6.46849C7.55806 6.48897 7.5879 6.5002 7.61875 6.5H8.38313C8.41398 6.5002 8.44381 6.48897 8.46689 6.46849C8.48997 6.44801 8.50465 6.41972 8.50813 6.38906C8.53538 6.14491 8.65155 5.91933 8.83449 5.75535C9.01743 5.59138 9.25433 5.50048 9.5 5.5H11.25C11.496 5.50002 11.7334 5.59071 11.9167 5.75473C12.1 5.91875 12.2165 6.14459 12.2437 6.38906C12.2472 6.41972 12.2619 6.44801 12.285 6.46849C12.3081 6.48897 12.3379 6.5002 12.3687 6.5H12.5C12.7844 6.49986 13.0674 6.54038 13.3403 6.62031C13.3589 6.6257 13.3786 6.62667 13.3977 6.62315C13.4167 6.61964 13.4347 6.61173 13.4502 6.60006C13.4657 6.58839 13.4783 6.57327 13.4869 6.5559C13.4956 6.53854 13.5 6.5194 13.5 6.5V4.25C13.5 3.78587 13.3156 3.34075 12.9874 3.01256C12.6592 2.68437 12.2141 2.5 11.75 2.5Z" fill="black" fillOpacity="0.8" />
                                            </svg>
                                            {lines.content.bedroom ? lines.content.bedroom : ""}
                                            <svg width="16" height="16" className="marg-left-10 marg-right-5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12.9565 2.02497C12.8737 1.9145 12.8961 1.7578 13.0066 1.67499C13.117 1.59216 13.2737 1.61459 13.3565 1.72506L14.1999 2.85006C14.2665 2.93892 14.2665 3.0611 14.1999 3.14997L13.3565 4.27497C13.2737 4.38545 13.117 4.40786 13.0066 4.32505C12.8961 4.24222 12.8737 4.08554 12.9565 3.97506L13.5 3.25001H5.76862L6.34152 3.96926C6.42753 4.07725 6.40972 4.23453 6.30172 4.32056C6.19373 4.40658 6.03644 4.38877 5.95042 4.28077L5.05433 3.15577C4.98173 3.06462 4.98173 2.9354 5.05433 2.84426L5.95042 1.71926C6.03644 1.61126 6.19373 1.59344 6.30172 1.67946C6.40972 1.76549 6.42753 1.92277 6.34152 2.03077L5.76862 2.75001H13.5L12.9565 2.02497Z" fill="black" />
                                                <path fillRule="evenodd" clipRule="evenodd" d="M14.25 5.56252C14.25 5.28638 14.0261 5.06252 13.75 5.06252H5.4375C5.16136 5.06252 4.9375 5.28638 4.9375 5.56252V14C4.9375 14.2761 5.16136 14.5 5.4375 14.5H13.75C14.0261 14.5 14.25 14.2761 14.25 14V5.56252ZM5.4375 5.56252H13.75V14H5.4375V5.56252Z" fill="black" />
                                                <path d="M4.07502 13.2566C3.9922 13.1463 3.83549 13.1238 3.72502 13.2066L2.99998 13.7501V6.01877L3.71922 6.59165C3.82722 6.67768 3.98451 6.65987 4.07053 6.55187C4.15656 6.44387 4.13875 6.28658 4.03075 6.20055L2.90573 5.30447C2.81461 5.23187 2.68536 5.23187 2.59423 5.30447L1.46923 6.20055C1.36123 6.28658 1.34336 6.44387 1.42948 6.55187C1.51548 6.65987 1.67273 6.67768 1.78073 6.59165L2.49998 6.01877V13.7501L1.77498 13.2066C1.66448 13.1238 1.50773 13.1463 1.42498 13.2566C1.34211 13.3671 1.36461 13.5239 1.47498 13.6066L2.59998 14.45C2.68886 14.5166 2.81111 14.5166 2.89998 14.45L4.02494 13.6066C4.13542 13.5239 4.15783 13.3671 4.07502 13.2566Z" fill="black" />
                                            </svg>
                                            {lines.content.size.builtUp ? Number(lines.content.size.builtUp).toLocaleString("en-US") : ""}
                                            {lines.content.size.unit ? lines.content.size.unit.replace(/\s+/g, '').toLowerCase() : ""}
                                        </td>

                                        <td>{lines.content.address.address ? (
                                            lines.content.address.address.length > 20 ? lines.content.address.address.slice(0, 20) + '...' : lines.content.address.address
                                        ) : (
                                            (() => {
                                                const { subCommunity = '', Community = '', city = '' } = lines.content.address;
                                                const fullAddress = `${subCommunity} ${Community} ${city}`.trim();

                                                return fullAddress.length > 20 ? fullAddress.slice(0, 20) + '...' : fullAddress;
                                            })()
                                        )}</td>

                                        <td>{lines.content.agent ? lines.content.agent.name : ""}</td>
                                        <td>{lines.status && <>
                                            {(lines.status.published == false && lines.status.state === "Draft") ? <span className="badge border-81 bg-label-warning">Draft </span> :
                                                (lines.status.published == true && lines.status.portals.length != 0 && lines.status.state === "Published") ?
                                                    <span className="badge border-81 bg-label-success">Published</span> :
                                                    <span className="badge border-81 bg-label-danger">Unpublished </span>}
                                        </>}
                                        </td>
                                        <td className="actions">
                                            <EditListing property={lines} onUpdateProperty={UpdatePropertyHandler} />
                                            <button type="button" className="btn p-0  hide-arrow" onClick={() => view(lines._id)}>
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clipPath="url(#clip0_830_3470)">
                                                        <path d="M19.8251 5.81598L14.4084 0.19104C14.2317 0.00778373 13.9609 -0.0497413 13.7251 0.0451673C13.4885 0.140991 13.3334 0.370176 13.3334 0.625147V3.33355H13.1252C8.64522 3.33355 5.00024 6.97853 5.00024 11.4585V12.7084C5.00024 12.9984 5.2044 13.2401 5.48684 13.306C5.53277 13.3176 5.57855 13.3226 5.62432 13.3226C5.86022 13.3226 6.08605 13.1842 6.19515 12.9668C7.36686 10.6226 9.72263 9.16677 12.3435 9.16677H13.3334V11.875C13.3334 12.1301 13.4885 12.3593 13.7251 12.4542C13.9593 12.5501 14.2317 12.4918 14.4084 12.3084L19.8251 6.68343C20.0584 6.44097 20.0584 6.05935 19.8251 5.81598Z" fill="black" />
                                                        <path d="M17.5 19.9999H2.50022C1.1219 19.9999 0.000244141 18.8784 0.000244141 17.5V5.83352C0.000244141 4.45521 1.1219 3.33355 2.50022 3.33355H5.00019C5.461 3.33355 5.83346 3.70601 5.83346 4.16682C5.83346 4.62763 5.461 5.0001 5.00019 5.0001H2.50022C2.04017 5.0001 1.66679 5.37347 1.66679 5.83352V17.5C1.66679 17.96 2.04017 18.3334 2.50022 18.3334H17.5C17.9599 18.3334 18.3333 17.96 18.3333 17.5V10.8335C18.3333 10.3727 18.7058 10 19.1666 10C19.6276 10 20 10.3727 20 10.8335V17.5C20 18.8784 18.8784 19.9999 17.5 19.9999Z" fill="black" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_830_3470">
                                                            <rect width="20" height="20" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>

                                            </button>
                                            <DeleteProperty propertyId={lines._id} onDeleteProperty={DeletePropertyHandler} />
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex justify-content-center padd-15-30 mb-4">
                        {propertiesLenght == 0 && isLoadingData == false && <h3 className="empty"> {t('messageProperties.noProperties')}</h3>}

                        {isLoadingData == true ? <div className="row ">
                            <div className="col-auto">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>

                            : propertiesLenght !== 0 && <Pagination count={totalPage} variant="outlined" shape="rounded" style={{ marginBottom: "16px" }} onChange={handleChangePagination} />}
                    </div>
                </div>
            </div>

            <Snackbar open={openSnackbar} onClose={handleCloseSnackbar}>
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={colorSnackbar || "info"}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </div >
    )
}
export default Properties